export default {
  user: null,
  token: null,
  auth: false,
  authPending: false,
  timeBeforeExpire: [5, 'minutes'],
  askTokenRefresh: 0,
  grants: null
}
